export const saveTheDateDesignsPageData = {
  seo: {
    title: 'Save the Date Cards | Paper + Free Online Templates | Joy',
    content:
      'Hundreds of free online Save The Date card templates with matching wedding websites and prints available through our amazing print partners.',
  },
  hero: {
    eyebrow: 'Send Smarter',
    title: 'Save the Dates',
    cta: 'Get Started',
    posterUrl: 'save-the-date-gallery/hero.jpg',
    videoUrl:
      'https://player.vimeo.com/video/1007823008?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
  },
  wonderfulWebsiteSection: {
    eyebrow: 'Wedding Website to Match',
    title: 'A wonderful site to see.',
    body:
      'Create a wedding website that is uniquely yours. Show off your engagement photos or video, share your wedding registry, and even help guests book travel.',
    learnMore: 'Learn More',
    videoUrl:
      'https://player.vimeo.com/video/996437845?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    posterUrl: 'save-the-date-gallery/matching-website.jpg',
  },
  highQualityPrintsSection: {
    eyebrow: 'High-Quality Prints',
    title: 'To Have <i>and</i> To Hold',
    body:
      'Printing and mailing? Our Save the Date templates with matching prints from our partners let you add premium touches. So  whether you’re selecting foil color, letterpress, or a matte finish monogram, create beautiful Save the Dates that match your wedding day effortlessly.',
    exploreDesigns: 'Explore Designs',
  },
  highQualityPrintsSectionV2: {
    eyebrow: 'High-Quality Prints',
    title: 'To Have <i>and</i> To Hold',
    body:
      'Printing and mailing? Our paper Save the Dates with matching digital cards let you add premium touches. So whether you’re selecting gold foil, showcasing your favorite photographs, or uploading a custom design unique to you, you’ll have beautiful keepsake Save the Dates that match your wedding day effortlessly. ',
    ctaText: 'Explore Designs',
    ctaLink: '/cards/wedding/save-the-date?scenario=save-the-date',
    leftImageData: {
      desktopImageUrl: 'save-the-date-gallery/alpine_wreath.png',
      mobileImageUrl: 'save-the-date-gallery/rustic_chic_mobile.png',
    },
    rightImageData: {
      desktopImageUrl: 'save-the-date-gallery/rustic-chic.png',
      mobileImageUrl: 'save-the-date-gallery/alpine_wreath_mobile.png',
    },
  },
  howItWorksSection: {
    eyebrow: 'How It Works',
    title: 'Announce your big day, your way.',
    body:
      'From custom Save the Date cards that match your free website to a guest list ready for all your details, this is the smarter way to plan your big day.',
    getStarted: 'Get Started',
    createInvite: {
      eyebrow: '1',
      title: 'Create the perfect design for your big reveal.',
      body:
        'Start with a stunning design template and turn it into personalized Save the Dates in the time it takes to say “I do.” Select fonts, colors, and art to make your own design. Craft a classic with an art deco style, make a splash with watercolor greenery, or go simple with a minimalist design with clean typography.',
      imageUrl: 'save-the-date-gallery/std-design.png',
    },
    guestList: {
      eyebrow: '2',
      title: 'Share your love story with a free wedding website.',
      body:
        'Remind family how you met, display your favorite engagement photos (or video), and share any important info you’ve solidified, from your wedding date and location to travel booking tips. The best part? Your website can grow and change as you solidify your plans.',
      imageUrl: 'save-the-date-gallery/ww.png',
    },
    finallyRSVP: {
      eyebrow: '3',
      title: 'Send out Save the Dates that help save the day.',
      body:
        'With easy Add to Calendar, your guests will be sure to get you in their schedule. When you’re ready to send, you’ve got a head start on your wedding planning, from managing plus ones to powerful RSVP features, even address collection. All tracked by your Connected Guest List.',
      imageUrl: 'save-the-date-gallery/add-to-cal.png',
    },
  },
  howItWorksSectionV2: {
    eyebrow: 'How It Works',
    title: 'Announce your big day, your way.',
    body:
      'From custom Save the Dates that match your free website to a guest list ready for all your details, this is the smarter way to plan your big day.',
    getStarted: 'Get Started',
    section1: {
      eyebrow: '1',
      title: 'Create the perfect design for your big reveal.',
      body:
        'Start with a stunning design template and turn it into personalized Save the Dates in the time it takes to say “I do.” Select fonts, colors, and art to make your own design. Craft a classic with an art deco style, make a splash with watercolor greenery, or go simple with a minimalist design with clean typography. Already have your own artwork? Upload your finished design to send a custom Save the Date through Joy.',
      imageUrl: 'save-the-date-gallery/customize.jpg',
      videoUrl:
        'https://player.vimeo.com/video/1007056496?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    },
    section2: {
      eyebrow: '2',
      title: 'Collect your guests’ contact info with one magic link.',
      body:
        'Craft your magic link, share it with your guests, and that’s it! They fill out a form that automatically updates their info on your guest list. Use their information to address your printed Save the Dates, or include the link in your digital Save the Dates to collect addresses for your wedding invitations.',
      imageUrl: 'save-the-date-gallery/contact-collector.jpg',
      videoUrl:
        'https://player.vimeo.com/video/1009953391?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    },
    section3: {
      eyebrow: '3',
      title: 'Share your joy, your way.',
      body:
        'Whether you prefer traditional paper cards or digital Save the Dates, we’ve got you covered. However you choose to share your big day, your guests will be sure to get the message. With recipient tracking for digital cards and free envelope addressing for paper invitations, sharing the excitement has never been easier.',
      imageUrl: 'save-the-date-gallery/share.jpg',
      videoUrl:
        'https://player.vimeo.com/video/1007758546?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    },
  },
  invitationSmartRSVPSection: {
    eyebrow: 'Smart RSVP',
    title: 'The best kind of know-it-all.',
    body:
      'Create custom RSVP questions to ask your guests about their meal selections, travel plans, and anything else. Ask private questions only for specific groups of guests, and even follow-up questions based on their answers.',
    exploreRSVP: 'Explore RSVP',
  },
  ecoSectionData: {
    eyebrow: 'Environmentally-Friendly Save the Dates',
    title: 'Share your love with the planet.',
    content:
      'With a tree planted in your honor for every print order, your Save the Dates are planet positive. And with online Save the Dates and your connected guest list, you’re saving more than time and money.',
    contentMobile:
      'With a tree planted in your honor for every print order, your Save the Dates are planet positive. And with online Save the Dates and your connected guest list, you’re saving more than time and money.',
    altText: 'Environmental image',
  },
  faq: {
    title: 'Frequently Asked Questions',
    description: 'Take a look at our most commonly asked questions and answers. For additional support chat with us.',
  },
};
